// extracted by mini-css-extract-plugin
export default {"tweet_container_container":"tweet-container_tweet_container_container__h4+tU"};